<template>
  <v-snackbar
    v-model="snackbar"
    transition="slide-x-reverse-transition"
    outlined
    :color="type == 'error' ? '#FF5722': '#19D3DA'"
    :class="type == 'error' ? 'error-message' : 'success-message'"
    min-height="60"
    width="300"
  >
    <p v-if="message" class="ma-0">
      {{message}}
    </p>
    <p v-else class="ma-0">
      Die Aktion konnte leider nicht ausgeführt werden, bitte versuche es noch einmal.
    </p>
  </v-snackbar>
</template>

<script>
export default {
	name: 'FlyInMessage',
	props: {
		type: { type: String, default: 'success' },
		message: { type: String }
	},
	data () {
		return {
			snackbar: false
		}
	},
	computed: {},
	methods: {
		show () {
			this.snackbar = true
		},
		hide () {
			this.snackbar = false
		}
	}
}
</script>

<style scoped>
.error-message, .success-message{
  justify-content: flex-end;
}
.success-message >>> .v-snack__wrapper {
  border-left: 10px solid rgba(25, 211, 218, 0.6) !important;
  border-color: rgba(25, 211, 218, 0.6) !important;
  border-radius: 3px 1px 1px 3px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  margin-bottom: 50px
}

.error-message >>> .v-snack__wrapper {
  border-left: 10px solid rgba(255, 87, 34, 0.6) !important;
  border-color: rgba(255, 87, 34, 0.6) !important;
  border-radius: 3px 1px 1px 3px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  margin-bottom: 50px;
}

.v-snack >>> .v-snack__wrapper .v-snack__content {
  font-family: 'Karla';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
